import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Box, CardContent, Typography } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import HeaderPageItem from "../custom/HeaderPageItem";
import PageContainer, { CardPageItem } from "../custom/Page";

const Management = () => {
  return (
    <PageContainer>
      <HeaderPageItem title="app.management" />

      <ManagementCard
        to="/customer-management"
        titleId="app.customer.management"
        marginTop={4}
      />

      <ManagementCard
        to="/team-management"
        titleId="app.team.management"
        marginTop={4}
      />
    </PageContainer>
  );
};

const ManagementCard = ({ to, titleId, marginTop }) => (
  <CardPageItem
    raised
    component={Link}
    to={to}
    style={{ textDecoration: "none", marginTop }}
  >
    <CardContent>
      <Typography
        variant="h6"
        color="primary"
        align="center"
        gutterBottom
      >
        <FormattedMessage id={titleId} />
      </Typography>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        padding={4}
      >
        <Typography
          variant="subtitle1"
          color="textPrimary"
        >
          <FormattedMessage id="app.clickHereToAccess" />
        </Typography>

        <ChevronRightIcon color="primary" />
      </Box>
    </CardContent>
  </CardPageItem>
);

export default React.memo(Management);
